import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button, Card, Divider, Modal, Row, Spacer, Text } from "@nextui-org/react";
import { ErrorMessage, Formik } from "formik";
import React, { useCallback, useMemo, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { BUG_REPORT_API } from "../helpers";
import styles from "./bug-report.module.less";
import { Input } from "./controls/formik-wrapped";
import { Icon } from "./fa-icon";
export var BugReport = function BugReport() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var onReportBug = useCallback(function () {
    setActive(true);
  }, []);
  var submitBugReport = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(bugReport) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return BUG_REPORT_API.Report(bugReport);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var validationSchema = useMemo(function () {
    return Yup.object({
      title: Yup.string().ensure().trim().required(),
      description: Yup.string().ensure().trim().required(),
      url: Yup.string().ensure().trim().matches(/^$|^https?:\/\/(?:localhost|resume\.jerbear\.dev)/i)
    });
  }, []);

  if (!active) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.bugReportWidget
    }, /*#__PURE__*/React.createElement(Button, {
      size: "xs",
      flat: true,
      auto: true,
      css: {
        p: "12px"
      },
      onClick: onReportBug,
      title: "Report a bug"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "bug"
    })));
  } // TODO use Formik


  return /*#__PURE__*/React.createElement(Modal, {
    open: true,
    blur: true,
    onClose: function onClose() {
      setActive(false);
    },
    width: "80%"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Text, {
    h1: true
  }, "Report a bug")), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Text, null, "Please fill out the following information"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      title: "",
      description: "",
      url: location.href
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, _ref2) {
        var setSubmitting;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setSubmitting = _ref2.setSubmitting;
                _context2.next = 3;
                return submitBugReport(values);

              case 3:
                toast.success("Bug report submitted--thank you!");
                setSubmitting(false);
                setActive(false);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, function (_ref4) {
    var errors = _ref4.errors,
        handleSubmit = _ref4.handleSubmit,
        isSubmitting = _ref4.isSubmitting;
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement(Row, {
      className: styles.row
    }, /*#__PURE__*/React.createElement(Input, {
      name: "title",
      label: "Summary",
      status: errors.title ? "error" : "primary",
      fullWidth: true,
      required: true,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "title",
      component: "div"
    })), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Row, {
      className: styles.row
    }, /*#__PURE__*/React.createElement(Input.Textarea, {
      name: "description",
      label: "Description",
      status: errors.description ? "error" : "primary",
      fullWidth: true,
      required: true,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "description",
      component: "div"
    })), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Row, {
      className: styles.row
    }, /*#__PURE__*/React.createElement(Input, {
      name: "url",
      label: "URL where error occurred",
      status: errors.url ? "error" : "primary",
      fullWidth: true,
      disabled: isSubmitting
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "url",
      component: "div"
    })), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit"
    }, "Submit Bug Report")));
  }))));
};